export default __webpack_public_path__ + "static/media/image3_cropped.0ebd7eb3.jpg";